import SvgIcon from '@mui/material/SvgIcon';
import * as React from 'react';
const SvgPaperPlane = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M20.652 3.147a.85.85 0 0 0-.895-.037l-16.33 9.28a.843.843 0 0 0 .09 1.511l5.395 2.264v3.99c0 .309.17.592.44.74.127.07.264.105.373.105a.85.85 0 0 0 .457-.134l3.913-2.512 3.469 1.455a.85.85 0 0 0 .742-.043.84.84 0 0 0 .42-.61L20.98 3.967a.775.775 0 0 0-.327-.82m-4.656 4.044-6.584 7.344-3.659-1.526zM10.57 18.609v-1.735l1.634.686zm6.676-.777-6.215-2.608 7.904-8.771z"
    }));
export default SvgPaperPlane;
